import { FaLanguage } from 'react-icons/fa'
import Icons from '../icon/icon.js'

const techSkills = [
  { icon: Icons.IconHtml, label: 'HTML5', filter: '' },
  { icon: Icons.IconCss, label: 'CSS3', filter: '' },
  { icon: Icons.IconJs, label: 'JavaScript', filter: '' },
  { icon: Icons.IconReact, label: 'React', filter: '' },
  { icon: Icons.IconExpressJs, label: 'Express.js', filter: 'invert(1)' },
  { icon: Icons.IconNetsuite, label: 'NetSuite', filter: '' }
]

const webSkills = [
  'JavaScript ES6+',
  'React / React Hooks',
  'Node.js',
  'REST APIs',
  'HTML5 / CSS3',
  'Responsive Design',
  'Git / Control de versiones',
  'JSON / XML',
  'npm / Gestión de paquetes',
  'Consumo de APIs externas'
]

const strongSkills = [
  'Análisis integral de procesos y requerimientos end-to-end',
  'Arquitectura CHRD / DRD',
  'Manejo CI/CD',
  'Control de Blueprint y manejo de estimación de tiempos'
]

const netsuiteSkills = [
  'SuiteScript 2.0 / 2.1',
  'SuiteCloud (SDF)',
  'SuiteApps',
  'SuiteBundle',
  'Freemarker / Advanced PDF',
  'WorkFlows (SuiteFlow)',
  'SuiteAnalytics SQL',
  'Búsquedas Guardadas',
  'Cargas Masivas'
]

export default function AboutMe() {
  return (
    <section
      id="acerca"
      className="pf-section"
      style={{ backgroundColor: 'var(--bg)' }}
    >
      <div className="container">
        <p className="pf-section__label">Sobre mí</p>
        <h2 className="pf-section__title">Acerca de mí</h2>
        <div className="pf-section__divider" />

        <div className="row">
          <div className="col-lg-7">
            <p className="pf-about__text">
              Manejo un stack moderno orientado al desarrollo web tanto en
              frontend como backend. En el frontend trabajo con React, HTML5,
              CSS3 y JavaScript (ES6+). En el backend utilizo Node.js y
              Express.js, lo que me permite construir APIs robustas y
              escalables.
            </p>
            <p className="pf-about__text">
              Además, tengo experiencia en el desarrollo con Oracle NetSuite,
              incluyendo personalizaciones, integraciones y automatizaciones
              empresariales. He construido aplicaciones web desde cero e
              integrado soluciones complejas con sistemas ERP.
            </p>
          </div>
        </div>

        {/* Tecnologías web */}
        <p className="pf-section__label mt-4">Tecnologías</p>
        <div className="pf-skills__grid mb-5">
          {techSkills.map(({ icon, label, filter }) => (
            <div key={label} className="pf-skill-badge">
              <img
                src={icon}
                alt={label}
                width={20}
                style={filter ? { filter } : {}}
              />
              {label}
            </div>
          ))}
        </div>

        {/* Web */}
        <p className="pf-section__label">Programación Web</p>
        <div className="pf-skills__grid mb-5">
          {webSkills.map((skill) => (
            <div key={skill} className="pf-skill-badge">
              {skill}
            </div>
          ))}
        </div>

        {/* NetSuite */}
        <p className="pf-section__label">NetSuite</p>
        <div className="pf-skills__grid mb-5">
          {netsuiteSkills.map((skill) => (
            <div key={skill} className="pf-skill-badge">
              <img src={Icons.IconNetsuite} alt="NetSuite" width={16} />
              {skill}
            </div>
          ))}
        </div>

        {/* Gestión y procesos */}
        <p className="pf-section__label">Gestión y Procesos</p>
        <ol className="pf-skill-list mb-5">
          {strongSkills.map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ol>

        {/* Idiomas */}
        <p className="pf-section__label">Idiomas</p>
        <div className="pf-skills__grid">
          <div className="pf-skill-badge">
            <FaLanguage size={18} style={{ color: 'var(--accent)' }} />
            Español — Nativo
          </div>
          <div className="pf-skill-badge">
            <FaLanguage size={18} style={{ color: 'var(--accent)' }} />
            Inglés — B1
          </div>
        </div>
      </div>
    </section>
  )
}
